declare global {
    interface RouterMeta {
        title: string;
        hidden?: boolean;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}

import main from '../views/main.vue'
import util from '@/lib/util';

const isStandardEdition = util.isStandardEdition(); // 是否标准版

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const refreshRouter: Router = {
    path: '/refresh',
    name: 'refresh',
    meta: {
        title: 'refresh'
    },
    component: () => import('../views/refresh.vue')
};
export const defaultRouter: Router = {
    path: '/',
    name: 'default',
    meta: {
        title: "HomePage"
    },
    component: () => import('../views/home.vue')
};
export const vendorHomeRouter: Router = {
    path: '/vendor',
    name: 'vendorHome',
    meta: {
        title: "VendorHomePage"
    },
    component: () => import('../views/vendorHome.vue')
};
export const loginRouter: Router = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const registerRouter: Router = {
    path: '/register',
    name: 'register',
    meta: {
        title: 'Register'
    },
    component: () => import('../views/register.vue')
};
export const loginCallbackRouter: Router = {
    path: '/login-callback',
    name: 'loginCallback',
    meta: {
        title: 'LoginCallback'
    },
    component: () => import('../views/loginCallback（OIDC）.vue')
};
export const searchRouter: Router = {
    path: '/search',
    name: 'search',
    meta: {
        title: 'Search'
    },
    component: () => import('../views/search/search.vue')
};
export const searchByImageRouter: Router = {
    path: '/search-by-image',
    name: 'searchByImage',
    meta: {
        title: 'SearchByImage'
    },
    component: () => import('../views/search/searchByImage.vue')
};
export const productDetailRouter: Router = {
    path: '/product',
    name: 'productDetail',
    meta: {
        title: 'ProductDetailPage'
    },
    component: () => import('../views/product/detail.vue')
};
export const checkoutRouter: Router = {
    path: '/checkout',
    name: 'checkout',
    meta: {
        title: 'CheckoutPage'
    },
    component: () => import('../views/product/checkout.vue')
};
export const productListRouter: Router = {
    path: '/product-list',
    name: 'productList',
    meta: {
        title: 'ProductListPage'
    },
    component: () => import('../views/product/list.vue')
};
export const similarListRouter: Router = {
    path: '/similar-list',
    name: 'similarList',
    meta: {
        title: 'SimilarListPage'
    },
    component: () => import('../views/product/similarList.vue')
};
export const productFindingListRouter: Router = {
    path: '/finding-list',
    name: 'findingList',
    meta: {
        title: 'ProductFindingListPage'
    },
    component: () => import('../views/productFinding/list.vue')
};
export const productFindingDetailRouter: Router = {
    path: '/finding',
    name: 'findingDetail',
    meta: {
        title: 'ProductFindingDetailPage'
    },
    component: () => import('../views/productFinding/detail.vue')
};

// Subject routers
export const aboutUsRouter: Router = {
    path: '/about-us',
    name: 'aboutus',
    meta: { title: 'AboutUsPage' },
    component: () => import('../views/subject.vue')
};
export const contactUsRouter: Router = {
    path: '/contact-us',
    name: 'contactus',
    meta: { title: 'ContactUsPage' },
    component: () => import('../views/subject.vue')
};
export const vendorRegisterInstructionsRouter: Router = {
    path: '/vendor-register-instructions',
    name: 'vendorregisterinstructions',
    meta: { title: 'VendorRegisterInstructions' },
    component: () => import('../views/subject.vue')
};
export const buyingInstructionsRouter: Router = {
    path: '/buying-instructions',
    name: 'BuyingInstructions',
    meta: { title: 'BuyingInstructions' },
    component: () => import('../views/subject.vue')
};
export const ruleAndAgreementRouter: Router = {
    path: '/rule-and-agreement',
    name: 'RuleAndAgreement',
    meta: { title: 'RuleAndAgreement' },
    component: () => import('../views/subject.vue')
};
export const appRouters: Array<Router> = [
    {
        path: '/pc',
        name: 'personal',
        permission: '',
        meta: { title: 'Personal' },
        icon: 'ios-leaf-outline',
        component: main,
        children: [
            { path: 'home', meta: { title: 'PersonalCenterHomePage' }, name: 'home', component: () => import('../views/personalHome.vue') },
            { path: 'favorite', meta: { title: 'FavoritePage' }, name: 'FavoriteItem', component: () => import('../views/shoppingCart/FavoriteItem/listFavoriteItem_modified.vue') },
            { path: 'orders', meta: { title: 'MyOrdersPage', hidden: (isStandardEdition ? true : false) }, name: 'Orders', component: () => import('../views/ordering/Orders/buyerOrders.vue') },
            { path: 'change-password', meta: { title: 'ChangePassword' }, name: 'changePassword', component: () => import('../views/setting/user/changePassword.vue') },
            { path: 'email-binding', meta: { title: 'EmailBindingPage', hidden: true }, name: 'emailBinding', component: () => import('../views/setting/user/emailBinding.vue') },
            { path: 'profile', meta: { title: 'ProfilePage' }, name: 'profile', component: () => import('../views/setting/UserProfile/editStandaloneUserProfile.vue') },
            { path: 'vip-register', meta: { title: 'VipRegisterPage', hidden: true }, name: 'vipRegister', component: () => import('../views/vipRegister.vue') },
            { path: 'coin-charging', meta: { title: 'CoinChargingPage', hidden: true }, name: 'coinCharging', component: () => import('../views/coinCharging.vue') },
            { path: 'shop-register', meta: { title: 'ShopRegisterPage', hidden: true }, name: 'shopRegister', component: () => import('../views/shopRegister.vue') },
            { path: 'product-finding', meta: { title: 'ProductFindingList', hidden: true }, name: 'ProductFinding', component: () => import('../views/baseInfo/ProductFinding/listProductFinding_modified.vue') },
        ]
    },
    // {
    //     path: '/vc',
    //     name: 'vendor',
    //     permission: '',
    //     meta: { title: 'Vendor' },
    //     icon: '&#xe68a;',
    //     component: main,
    //     children: [
    //         { path: 'shop-profile', permission: 'VendorPages.Vendor.Edit', meta: { title: 'ShopProfilePage' }, name: 'shopProfile', component: () => import('../views/setting/Vendor/editStandaloneVendor.vue') },
    //         { path: 'product', permission: 'VendorPages.Product', meta: { title: 'ProductManagement' }, name: 'product', component: () => import('../views/baseInfo/Product/listProduct_modified.vue') },
    //         { path: 'order-management', permission: 'VendorPages.Order', meta: { title: 'OrderManagement', hidden: (isStandardEdition ? true : false) }, name: 'Order', component: () => import('../views/ordering/Orders/vendorOrders.vue') },
    //         { path: 'Withdrawal', permission: 'VendorPages.Withdrawal', meta: { title: 'WithdrawalList', hidden: true }, name: 'Withdrawal', component: () => import('../views/finance/Withdrawal/listWithdrawal_modified.vue') },
    //     ]
    // }
]
export const routers = [
    defaultRouter,
    loginRouter,
    loginCallbackRouter,
    registerRouter,
    searchRouter,
    searchByImageRouter,
    productDetailRouter,
    productListRouter,
    similarListRouter,
    checkoutRouter,
    vendorHomeRouter,
    locking,
    refreshRouter,
    productFindingListRouter,
    productFindingDetailRouter,
    aboutUsRouter,
    contactUsRouter,
    vendorRegisterInstructionsRouter,
    buyingInstructionsRouter,
    ruleAndAgreementRouter,
    ...appRouters,
];
